import {Box, Switch as GWCSwitch, Typography, TypographyVariants} from '@gwc/main'
import {memo} from 'react'

import {SwitchProps, SwitchSize} from './Switch.types'

const typographyVariants: Record<SwitchSize, TypographyVariants> = {
  s: 'caption1',
  m: 'body2',
}

const Switch = memo(function Switch({label, size = 'm', on, ...switchProps}: SwitchProps) {
  return (
    <Box alignItems="center" flexWrap="nowrap">
      <GWCSwitch on={on} size={size} {...switchProps} />
      {!!label && (
        <Typography Component="label" htmlFor={switchProps.name} ml="m" variant={typographyVariants[size]}>
          {label}
        </Typography>
      )}
    </Box>
  )
})

export default Switch
